import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/create/resources/computed.js